import { mediaConstants } from './../_constants';

export function listMediaReducer(state = {}, action) {
  switch ( action.type ) {
    case mediaConstants.LIST_MEDIA_SUCCESS:
      return {
        media: {
          type: 'alert-success',
          message: action.message
        }
      }
    case mediaConstants.LIST_MEDIA_FAILURE:
      return {
        media: {
          type: 'alert-failure',
          message: action.failure
        }
      }
    default:
      return state
  }
}